// Standalone entry — lets `pnpm --filter search dev` open the remote by
// itself for iteration. In the shell, MF loads `./Search` directly.
import("./bootstrap");
export {};
